import { render, staticRenderFns } from "./NewDispatch.vue?vue&type=template&id=cde6c4d0"
import script from "./NewDispatch.vue?vue&type=script&lang=js"
export * from "./NewDispatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports